"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Owner_1 = require("./_Owner");
exports._DeleteMarkerEntry = {
    type: "structure",
    required: [],
    members: {
        Owner: {
            shape: _Owner_1._Owner
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        VersionId: {
            shape: {
                type: "string"
            }
        },
        IsLatest: {
            shape: {
                type: "boolean"
            }
        },
        LastModified: {
            shape: {
                type: "timestamp"
            }
        }
    }
};
//# sourceMappingURL=_DeleteMarkerEntry.js.map